import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { GlobalHeader } from '@sdtech/react-header-and-footer';
import GlobalFooter from '@sdtech/sd-ui/GlobalFooter';
import Alert from '@sdtech/sd-ui/Alert';

import GenericError from './genericError';
import UrlFormatError from './atp/urlFormatError';
import LinkExpiredError from './atp/linkExpiredError';
import CookiesDisabledError from './atp/cookiesDisabledError';
import DownloadPdfError from './spdf/downloadPdfError';
import GURLUnableToResolveError from './gurl/gurlUnableToResolveError';
import idPlusCookiesDisabledError from './atn/idPlusCookiesDisabledError';
import maintenanceError from './atn/maintenanceError';
import AuthShareTimeoutError from './atp/authShareTimeoutError';

const errorMessages = {
  'ATN-20': idPlusCookiesDisabledError,
  'ATN-23': maintenanceError,
  'ATP-1': UrlFormatError,
  'ATP-2': LinkExpiredError,
  'ATP-3': CookiesDisabledError,
  'ATP-4': AuthShareTimeoutError,
  'GURL-1': GURLUnableToResolveError,
  'GURL-2': GURLUnableToResolveError,
  'SPDF-1': DownloadPdfError,
  'SPDF-2': DownloadPdfError,
  default: GenericError,
};

export function ErrorComp(props) {
  const {code} = useParams();
  const query = get(props, 'location.query', {});

  let errorCode;
  if (code) {
    const foundPrefix = code.match(/^([a-zA-Z]+)-\d+$/);
    if (foundPrefix && props.expectedErrorCodePrefixes.includes(foundPrefix[1])) {
      errorCode = code;
    }
  }

  const ErrorMessage = errorMessages[errorCode] || errorMessages.default;

  return (
    <div>
      <GlobalHeader
        config={props.reactHeaderFooterConfig.config}
        requestPath={props.reactHeaderFooterConfig.requestPath}
      />
      <div id="sd-ai-navigation-container"></div>
      <div className="grid">
        <div className="row u-bg-grey7 u-clr-white u-padding-l-ver u-padding-s-hor">
          <div className="col-xl-6 col-lg-4"/>
          <div className="col-xl-12 col-lg-16 col-xs-24">
            <Alert type="warning">
              <div className="u-clr-white">
                <ErrorMessage query={query} errorCode={errorCode}/>
                {errorCode && (
                  <div className="u-padding-m-top">
                    Error code: {errorCode}
                  </div>
                )}
              </div>
            </Alert>
          </div>
        </div>
      </div>
      <GlobalFooter
        config={props.reactHeaderFooterConfig.config}
        requestPath={props.reactHeaderFooterConfig.requestPath}
      />
    </div>
  );
}

ErrorComp.propTypes = {
  expectedErrorCodePrefixes: PropTypes.array,
  reactHeaderFooterConfig: PropTypes.object,
};

const mapStateToProps = ({config}) => ({
  ...config,
  expectedErrorCodePrefixes: config.expectedErrorCodePrefixes,
});

export default connect(mapStateToProps)(ErrorComp);
